"use client";

import { Icons } from "@/components/icons";

interface MobileShareButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    slug: string;
}

export function MobileShareButton({ title, slug, ...props}: MobileShareButtonProps) {
  const handleShare = async () => {
    console.log('share button clicked')
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'SuperStack',
          text: `Check out @${slug} on SuperStack!`,
          url: window.location.href,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      // fallback for browsers that don't support the Web Share API
      console.log('Web Share API not supported');
    }
  };

  return (
    <button className="my-2 flex flex-row justify-between items-center w-full" onClick={handleShare}>
        <div className="flex items-center">
            <Icons.share width="24" height="24" />
            <p className="ml-4">{title}</p>
        </div>
        <div>
            <Icons.chevronRight width="24" height="24"/>
        </div>
    </button>
  );
};